import { Component, OnInit, AfterViewInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

    isMobileNavbarOpen: boolean = false;
    @ViewChild('routerContainer', { static: true }) routerContainer!: ElementRef;

    mobileLinks = [
        { href: '/home', text: 'Home' },
        { href: '/meteo', text: 'Meteo' },
        { href: '/tempo-reale', text: 'Tempo Reale' },
        { href: '/dati', text: 'Dati' },
        { href: '/documenti', text: 'Documenti' },
        { href: '/ict-radio', text: 'ICT' },
        { href: '/news', text: 'News' },
        { href: '/chi-siamo', text: 'Chi siamo' }
    ];

    constructor(private router: Router, private renderer : Renderer2) {}

    ngOnInit() {
        
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            setTimeout(() => {
                this.scrollToTop();
            }, 50); // Attendi 50ms per garantire che il rendering sia completato
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.scrollToTop(); // Forza lo scroll dopo il rendering completo
        }, 50);
    }

    scrollToTop() {
        const topElement = document.getElementById('top');
        if (topElement) {
            topElement.scrollIntoView({ behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    toggleMobileNavbar() {
        this.isMobileNavbarOpen = !this.isMobileNavbarOpen;
      
        if (this.isMobileNavbarOpen) {
          this.renderer.addClass(document.body, 'modal-open');
        } else {
          this.renderer.removeClass(document.body, 'modal-open');
        }
      }

    navigateTo(path: string) {
        this.router.navigate([path]);
        this.toggleMobileNavbar(); // Chiude il menu dopo la navigazione
    }
}



// ngOnInit() {
//     var navbar : HTMLElement = this.element.nativeElement.children[0].children[0];
//     this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
//         if (window.outerWidth > 991) {
//             window.document.children[0].scrollTop = 0;
//         }else{
//             window.document.activeElement.scrollTop = 0;
//         }
//         this.navbar.sidebarClose();

//         this.renderer.listen('window', 'scroll', (event) => {
//             const number = window.scrollY;
//             var _location = this.location.path();
//             _location = _location.split('/')[2];

//             if (number > 150 || window.pageYOffset > 150) {
//                 navbar.classList.remove('navbar-transparent');
//             } else if (_location !== 'login' && this.location.path() !== '/nucleoicons') {
//                 // remove logic
//                 navbar.classList.add('navbar-transparent');
//             }
//         });
//     });
// }